import React,{useState,useEffect,useRef} from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Icon from '@material-ui/core/Icon';
//import { configure, setAddon } from '@storybook/react';
import { BreadcrumbPage } from "../../shared";
import CheckIcon from '@material-ui/icons/Check';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import { InputLabel,TextareaAutosize } from '@material-ui/core';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import { getCookie } from "../../services/Cookies";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
import {SupportFormat} from "./SupportFormat";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";

const useStyles=makeStyles(() => ({
  btn1:{
    border: '2px solid #FF4717',
    background: '#ff4717',
    color: '#fff !important',
    marginLeft: '20px !important',
    fontSize: '16px; font-weight: normal',
    padding: '8px 15px',
    width: '130px !important'

  },
  btn2:{
   
    border: '2px solid #FF4717',
    background: '#ff4717',
    color: '#fff !important',
    marginLeft: '20px !important',
    fontSize: '16px; font-weight: normal',
    padding: '8px 15px',
    width: '130px !important'
  },
  textstyles:{
    color:'#ff4717'
  }
})
) 

function Support (props) {
     const BreadcrumbList = [{ name: "Support", url: "" }];
     const classes=useStyles();
     const imageInputRef = React.useRef();
     const dispatch = useDispatch();
     const [formObj, setFormObj]=useState({...SupportFormat, UserEmail:getCookie("username"), Application:'Client Admin'});
     const [profilePic, setProfilePic] = useState(null);
     const { clearFilter} = props;
     const onSubmitAccount = () =>{
      //console.log(formObj, profilePic);
      if(!formObj.IssueDescription){
        ToastError('Issue description is required ')
      } /* else if(!profilePic){
        ToastError('Please select the image')
      } */ else {
        const formData = new FormData();
        formData.append("UserEmail", formObj.UserEmail);
        formData.append("Application", formObj.Application);
        formData.append("IssueDescription", formObj.IssueDescription);
        if(profilePic){
          formData.append("file", profilePic);
        } 
        updateSupportDetails(formData);
      }
    }
    const updateSupportDetails = async (data) => {
      //
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
        `SupportTicket/Submit`;
        
        dispatch({ type: LOADING, payload: true });
        await postRequest(url, data)
        .then((res) => {
          dispatch({ type: LOADING, payload: false });
          //console.log(res);
          setFormObj({...formObj, IssueDescription:''});
          imageInputRef.current.value = ""
          setProfilePic(null);
          ToastSuccess('Submitted successfully')
          })
        .catch((error) => {
          dispatch({ type: LOADING, payload: false });
          //console.log(error);
          
        });
    }
    const onTextChange = (event) => {
      setFormObj({ ...formObj, [event.target.name]: event.target.value });
      //console.log(event);
    };

    const onSubmitProfile = (event) => {
      //console.log(event.target.files[0],"img");
      //
      var file = event.target.files[0];
      setProfilePic(file);
      
  }
  const onClearFilter = () =>{
    setFormObj({...SupportFormat, UserEmail:getCookie("username"), Application:'Client Admin'});
    }      
 
    return (
        <div >
    <Form>
    <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
    <Form.Label column sm={6} >
      <h2 className={classes.textstyles}>SUPPORT FORM</h2>
    </Form.Label>
    
  </Form.Group>

  <Form.Group as={Row} controlId="formHorizontalEmail" className="justify-content-md-center">
    <Form.Label column sm={2}>
      User Email
    </Form.Label>
    <Col sm={4}>
      <Form.Control readOnly type="email"  defaultValue={formObj.UserEmail} name="UserEmail" />
    </Col>
  </Form.Group>

  <Form.Group as={Row} controlId="formHorizontalPassword" className="justify-content-md-center">
    <Form.Label column sm={2}>
      Application
    </Form.Label>
    <Col sm={4}>
      <Form.Control type="text" readOnly  defaultValue={formObj.Application}  name="Application" onChange={onTextChange} />
    </Col>
  </Form.Group>
  
  <Form.Group as={Row} controlId="formHorizontalPassword" className="justify-content-md-center">
    <Form.Label column sm={2} >
      Issue description
    </Form.Label>
    <Col sm={4}>
        <TextareaAutosize
        rowsMin={10}
        name="IssueDescription" value={formObj.IssueDescription}  onChange={onTextChange} maxlength="1000" style={{width:"100%",overflow:"auto",maxHeight:"150px"}}
        />
    </Col>
  </Form.Group>
  <Form.Group as={Row} controlId="formHorizontalPassword"   className="justify-content-md-center">
    <Form.Label column sm={2}>
      Attachments
    </Form.Label>
    <Col sm={4}>
    <Form.File id="exampleFormControlFile1"  
    style={{color:'black'}}
        onChange={onSubmitProfile}
        ref={imageInputRef} 
         />
    </Col>
  </Form.Group>

  
  
  

  <Form.Group as={Row} className="justify-content-md-center">
    <Col sm={{ span: 4, offset: 2 }}>
      <button type="button" className={classes.btn1} onClick={onSubmitAccount}>Submit</button>{''}
      <button type="reset" className={classes.btn2} onClick={onClearFilter} >Reset</button>
    </Col>
    
  </Form.Group>
</Form>
</div>
 )
}


export default Support

